import {IDataModel} from "../../services/IDataModel";
import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {
    IClientModel, ClientScheduleModel, ClientsFilter, ClientStatusModel,
    ClientFundingInformation
} from './clients.model';
import {BusinessLength, TimeFrame, Purpose, ClientStatusType, ClientsReasonType, DebtAccount, DebtAccountPending} from './clients.type';
import * as _ from "lodash";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Rx";
import {ListResponseModel, ResponseModel} from "../response/response.model";
import {ClientLocationsModel} from "../client-locations/client-locations.model";
import {LeadsModel} from "../leads/leads.model";

@Injectable()
export class ClientsService implements IDataModel {

    public static CLIENT_VISIBLE_SCHEDULE = 2;
    public static CLIENT_VISIBLE_TRUE = 1;
    public static CLIENT_VISIBLE_FALSE = 0;

    public static CLIENT_FILTER_TODAY = 'today';
    public static CLIENT_FILTER_OVERDUE = 'overdue';

    private API_ROOT:string = '/funding-specialist';

    constructor(private http: Http) {}

    public statusNames = {
        [ClientStatusType.INCOMPLETE]: 'Incomplete',
        [ClientStatusType.IN_DATA_ENTRY]: 'In Data entry',
        [ClientStatusType.IN_UNDERWRITING]: 'In underwriting',
        [ClientStatusType.APPROVED_NOT_FUNDED]: 'Approved not funded',
        [ClientStatusType.DECLINED]: 'Declined',
        [ClientStatusType.FUNDED]: 'Fund',
        [ClientStatusType.NEW_CLIENT]: 'New Client',

        [ClientStatusType.STATEMENT_NOT_PRICED]: 'Statement/not priced',
        [ClientStatusType.WAITING_ON_STATEMENT]: 'Waiting on Statement',
        [ClientStatusType.NO_ANSWER]: 'No Answer',
        [ClientStatusType.NOT_AVAILABLE]: 'Not available',
        [ClientStatusType.NOT_INTERESTED]: 'Not interested',
        [ClientStatusType.NOT_NOW_IN_THE_FUTURE]: 'Not now, in the future',
        [ClientStatusType.NOT_IN_SERVICE]: 'Not in service',
        [ClientStatusType.OUT_OF_BUSINESS]: 'Out of business',
        [ClientStatusType.SELLING_BUSINESS]: 'Selling business',
        [ClientStatusType.SCHEDULED_CALL_BACK]: 'Scheduled call back',

        [ClientStatusType.STATEMENT_PRICED]: 'Statement priced',
        [ClientStatusType.AGREEMENT_OUT]: 'Agreement out',
        [ClientStatusType.AGREEMENT_IN]: 'Agreement in',
        [ClientStatusType.COMPLETE]: 'Complete',
        [ClientStatusType.APPROVED_BY_DE]: 'Approved by Data Entry',
    };

    public businessLengthNames = {
        [BusinessLength.MONTH_LESS_THEN_6]: 'Less than 6 months',
        [BusinessLength.YEAR_LESS_THEN_1]: '6 - 12 Months',
        [BusinessLength.YEAR_1]: '1 Year',
        [BusinessLength.YEAR_2]: '2 Years',
        [BusinessLength.YEAR_3_4]: '3-4 Years',
        [BusinessLength.YEAR_5_7]: '5-7 Years',
        [BusinessLength.YEAR_8_10]: '8-10 Years',
        [BusinessLength.YEAR_11_13]: '11-13 Years',
        [BusinessLength.YEAR_14_17]: '14-17 Years',
        [BusinessLength.YEAR_18_20]: '18-20 Years',
        [BusinessLength.YEAR_MORE_20]: '20+ Years',
    };

    public debtAccountNames = {
        [DebtAccount.NO_ACTIVE_ACCOUNT]: 'No Active Account',
        [DebtAccount.DEBT_ACCOUNT_CREATED]: 'Debt Account Created',
        [DebtAccount.PENDING_REPAYMENT]: 'Pending Repayment',
        [DebtAccount.CLOSED]: 'Closed',
        [DebtAccount.REPAID]: 'Repaid',
        [DebtAccount.WRITTEN_OFF]: 'Written Off',
        [DebtAccount.PENDING_REPAYMENT_INKAS]: 'Pending Repayment - Inkas',
        [DebtAccount.PENDING_REPAYMENT_SPLIT_SETTLEMENT]: 'Pending Repayment- Split Settlement',
        [DebtAccount.PENDING_REPAYMENT_COLLECTIONS]: 'Pending Repayment - Collections / Legal',
    };

    public processingAccountNames = {
        [DebtAccountPending.PENDING_REPAYMENT]: 'Pending Repayment',
        [DebtAccountPending.PENDING_REPAYMENT_INKAS]: 'Pending Repayment - Inkas',
        [DebtAccountPending.PENDING_REPAYMENT_SPLIT_SETTLEMENT]: 'Pending Repayment- Split Settlement',
    };

    getList(filter: ClientsFilter) {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in filter) {

            if (key == 'fields') {
                for (let key in filter.fields) {
                    let fieldName = Object.keys(filter.fields[key])[0];
                    params.set(fieldName, filter.fields[key][fieldName]);
                }
            } else {
                params.set(key, filter[key] === null ? 'null' : filter[key]);
            }
        }
        return this.http
            .get(this.API_ROOT, new RequestOptions({
                search: params
            }));
    }

    getOne(id: number): Observable<ResponseModel<IClientModel>>  {
        return this.http.get(`${this.API_ROOT}/${id}`).map((res) => {
            let response: ResponseModel<IClientModel> = res.json();

            response.data.business_location = response.data.business_location || new ClientLocationsModel(); // todo
            response.data.mailing_location = response.data.mailing_location || new ClientLocationsModel(); // todo

            return response;
        });
    }

    getScheduleLIst() {
        return this.http.get(`${this.API_ROOT}/schedule`)
    }

    add (fields: IClientModel): Observable<ResponseModel<IClientModel>> {
        return this.http.post(this.API_ROOT, fields).map((res) => {
            let response: ResponseModel<IClientModel> = res.json();

            response.data.business_location = response.data.business_location || new ClientLocationsModel(); // todo
            response.data.mailing_location = response.data.mailing_location || new ClientLocationsModel(); // todo

            return response;
        });
    }

    quickAdd (fields: LeadsModel, salesNote: any = null) {
        let sendFields: any;
        if (salesNote) {
            sendFields = Object.assign({}, <any>fields, {salesNote: salesNote});
        } else {
            sendFields = fields;
        }
        return this.http.post(`${this.API_ROOT}/quick-add`, sendFields)
    }

    edit (id: number, fields: IClientModel): Observable<ResponseModel<IClientModel>>  {
        return this.http.put(`${this.API_ROOT}/${id}`, fields).map((res) => {
            let response: ResponseModel<IClientModel> = res.json();

            response.data.business_location = response.data.business_location || new ClientLocationsModel(); // todo
            response.data.mailing_location = response.data.mailing_location || new ClientLocationsModel(); // todo

            return response;
        });
    }

    setStatus (id: number, fields: ClientStatusModel) {
        return this.http.put(`${this.API_ROOT}/${id}/status`, fields).map(r => r.json())
    }

    setSchedule (id: number, fields: ClientScheduleModel) {
        return this.http.put(`${this.API_ROOT}/${id}/schedule`, fields)
    }

    remove(id: number) {
        return this.http.delete(`${this.API_ROOT}/${id}`).map(r => r.json())
    }

    sendInvite(id: number) {
        return this.http.put(`${this.API_ROOT}/${id}/send-invite`, {}).map(r => r.json());
    }

    getInvitationStatus(id: number) {
        return this.http.get(`${this.API_ROOT}/${id}/get-invitation-status`).map(r => r.json())
    }

    getForFloatingButton(id: any) {
        return this.http.get(`${this.API_ROOT}/${id}/get-for-floating-button`).map(r => r.json())
    }

    hasDebt(id: any) {
        return this.http.get(`/clients/${id}/has-debt`).map(r => r.json())
    }

    getCounts() {
        return this.http.get(`${this.API_ROOT}/counts`).map(r => r.json())
    }


    getFundingInformation(clientId): Observable<ResponseModel<ClientFundingInformation>>   {
        return this.http.get(`/clients/${clientId}/funding-information`).map(r => r.json())
    }

    getForExportAllClients(): Observable<ResponseModel<any>> {
        return this.http.get('/clients/export').map(r => r.json())
    }


    static getEmptyModel(): IClientModel {
        return {
            client_name: '',
            company_name: '',
            industry_id: null,
            email: '',
            telephone: '',
            business_age_id: null,
            avg_monthly_credit: '',
            financing_required: null,
            timeframe: null,
            purpose: null,
            closer_id: null,
            notes: null
        }
    }

    getBusinessLength(){
        return [
            {'id': BusinessLength.MONTH_LESS_THEN_6, 'name': 'Less than 6 months'},
            {'id': BusinessLength.YEAR_LESS_THEN_1, 'name': '6 - 12 Months'},
            {'id': BusinessLength.YEAR_1, 'name': '1 Year'},
            {'id': BusinessLength.YEAR_2, 'name': '2 Years'},
            {'id': BusinessLength.YEAR_3_4, 'name': '3-4 Years'},
            {'id': BusinessLength.YEAR_5_7, 'name': '5-7 Years'},
            {'id': BusinessLength.YEAR_8_10, 'name': '8-10 Years'},
            {'id': BusinessLength.YEAR_11_13, 'name': '11-13 Years'},
            {'id': BusinessLength.YEAR_14_17, 'name': '14-17 Years'},
            {'id': BusinessLength.YEAR_18_20, 'name': '18-20 Years'},
            {'id': BusinessLength.YEAR_MORE_20, 'name': '20+ Years'},
        ];
    }

    public getBusinessLengthById(id = null) {
        return _.find(this.getBusinessLength(), {id: id});
    }


    getTimeFrame(id = null){
        return [
            {'id': TimeFrame.IMMEDIATELY, 'name': 'Immediately'},
            {'id': TimeFrame.DAY_30, 'name': '30 Days'},
            {'id': TimeFrame.DAY_60, 'name': '60 Days'},
            {'id': TimeFrame.DAY_MORE_THEN_90, 'name': 'More than 90 Days'},
            {'id': TimeFrame.NOT_SURE, 'name': 'Not Sure'}
        ];
    }

    public getTimeFrameById(id = null) {
        return _.find(this.getTimeFrame(), {id: id});
    }

    getPurpose(){
        return [
            {'id': Purpose.EXPANSION, 'name': 'Expansion'},
            {'id': Purpose.RENOVATIONS, 'name': 'Renovations'},
            {'id': Purpose.INVENTORY, 'name': 'Inventory'},
            {'id': Purpose.CASH_FLOW, 'name': 'Cash Flow'},
            {'id': Purpose.TAXES, 'name': 'Taxes'},
            {'id': Purpose.RENT, 'name': 'Rent'},
            {'id': Purpose.OTHER, 'name': 'Other'}
        ];
    }

    getStatusNewLead() {
        return [
            {'id': ClientStatusType.WAITING_ON_STATEMENT,'name': 'Waiting on Statement'},
            {'id': ClientStatusType.NO_ANSWER,'name': 'No Answer'},
            {'id': ClientStatusType.NOT_AVAILABLE,'name': 'Not available'},
            {'id': ClientStatusType.NOT_INTERESTED,'name': 'Not interested'},
            {'id': ClientStatusType.NOT_NOW_IN_THE_FUTURE,'name': 'Not now, in the future'},
            {'id': ClientStatusType.NOT_IN_SERVICE,'name': 'Not in service'},
            {'id': ClientStatusType.OUT_OF_BUSINESS,'name': 'Out of business'},
            {'id': ClientStatusType.SELLING_BUSINESS,'name': 'Selling business'},
            {'id': ClientStatusType.NON_QUALIFIED,'name': 'Non qualified'},
            {'id': ClientStatusType.LOW_VOLUME,'name': 'Low volume'},
            {'id': ClientStatusType.SEASONAL,'name': 'Seasonal'},
        ];
    }

    getStatusNewLeadSchedule() {
        return [
            {'id': ClientStatusType.WAITING_ON_STATEMENT,'name': 'Waiting on Statement'},
            {'id': ClientStatusType.NO_ANSWER,'name': 'No Answer'},
            {'id': ClientStatusType.NOT_AVAILABLE,'name': 'Not available'},
            {'id': ClientStatusType.NOT_INTERESTED,'name': 'Not interested'},
            {'id': ClientStatusType.NOT_NOW_IN_THE_FUTURE,'name': 'Not now, in the future'},
            {'id': ClientStatusType.NOT_IN_SERVICE,'name': 'Not in service'},
            {'id': ClientStatusType.OUT_OF_BUSINESS,'name': 'Out of business'},
            {'id': ClientStatusType.SELLING_BUSINESS,'name': 'Selling business'},

            {'id': ClientStatusType.SEASONAL,'name': 'Seasonal'},
        ];
    }

    getStatusWaitingOnStatements() {
        return [
            
            {'id': ClientStatusType.NO_ANSWER,'name': 'No Answer'},
            {'id': ClientStatusType.NOT_AVAILABLE,'name': 'Not available'},
            {'id': ClientStatusType.NOT_INTERESTED,'name': 'Not interested'},
            {'id': ClientStatusType.NOT_NOW_IN_THE_FUTURE,'name': 'Not now, in the future'},
            {'id': ClientStatusType.NOT_IN_SERVICE,'name': 'Not in service'},
            {'id': ClientStatusType.OUT_OF_BUSINESS,'name': 'Out of business'},
            {'id': ClientStatusType.SELLING_BUSINESS,'name': 'Selling business'},
            {'id': ClientStatusType.NON_QUALIFIED,'name': 'Non qualified'},
            {'id': ClientStatusType.LOW_VOLUME,'name': 'Low volume'},
            {'id': ClientStatusType.SEASONAL,'name': 'Seasonal'},
        ];
    }

    getStatusNotPriced() {
        return [
            {'id': ClientStatusType.WAITING_ON_STATEMENT,'name': 'Waiting on Statement'},
            {'id': ClientStatusType.NO_ANSWER,'name': 'No Answer'},
            {'id': ClientStatusType.NOT_AVAILABLE,'name': 'Not available'},
            {'id': ClientStatusType.NOT_INTERESTED,'name': 'Not interested'},
            {'id': ClientStatusType.NOT_NOW_IN_THE_FUTURE,'name': 'Not now, in the future'},
            {'id': ClientStatusType.NOT_IN_SERVICE,'name': 'Not in service'},
            {'id': ClientStatusType.OUT_OF_BUSINESS,'name': 'Out of business'},
            {'id': ClientStatusType.SELLING_BUSINESS,'name': 'Selling business'},
            {'id': ClientStatusType.NON_QUALIFIED,'name': 'Non qualified'},
            {'id': ClientStatusType.LOW_VOLUME,'name': 'Low volume'},
            {'id': ClientStatusType.SEASONAL,'name': 'Seasonal'},
        ];
    }

    public getAllReasons() {
        return [
            {'id': ClientsReasonType.TOO_EXPENSIVE, 'name': "Too Expensive"},
            {'id': ClientsReasonType.DOESNT_NEED_MONEY, 'name': "Doesn't Need Money"},
            {'id': ClientsReasonType.SELLING_BUSINESS_REASON, 'name': "Selling Business"},
            {'id': ClientsReasonType.RETIRING, 'name': "Retiring"},
            {'id': ClientsReasonType.RECEIVED_MONEY_ELSEWHERE, 'name': "Received Money Elsewhere"},
            {'id': ClientsReasonType.NOT_ENOUGHT_MONEY, 'name': "Not Enough Money"},
            {'id': ClientsReasonType.WITHHOLDING, 'name': "Withholding"},
            {'id': ClientsReasonType.NO_PURPOSE, 'name': "No Purpose"},
            {'id': ClientsReasonType.CLOTHING_BUSINESS, 'name': "Closing Business"},
            {'id': ClientsReasonType.OTHER_REASON, 'name': "Other"}
        ];
    }

    getStatusPriced() {
        return [
            {'id': ClientStatusType.AGREEMENT_OUT,'name': 'Agreement out'},
        ];
    }

    getStatusAgreementOut() {
        return [
            {'id': ClientStatusType.AGREEMENT_IN,'name': 'Agreement in'},
        ];
    }

    getStatusApproved() {
        return [
            {'id': ClientStatusType.INCOMPLETE,'name': 'Incomplete'},
            {'id': ClientStatusType.FUNDED,'name': 'Fund'},
        ];
    }

    getStatusAgreementIn() {
        return [
            {'id': ClientStatusType.INCOMPLETE,'name': 'Incomplete'},
            {'id': ClientStatusType.COMPLETE,'name': 'Complete'},
        ];
    }

    getStatusAccounts() {
        return [
            {'id': ClientStatusType.WAITING_ON_STATEMENT,'name': 'Waiting on Statement'},
            {'id': ClientStatusType.STATEMENT_NOT_PRICED,'name': 'statements/not priced'},
        ];
    }

    getStatusIncomplete() {
        return [
            {'id': ClientStatusType.COMPLETE,'name': 'Complete'},
        ];
    }

    getStatusComplete() {
        // if (this.userOne.role == )
        return [
            {'id': ClientStatusType.INCOMPLETE,'name': 'Incomplete'},
            {'id': ClientStatusType.APPROVED_BY_DE,'name': 'Approved by Data Entry'},
        ];
    }

    getStatusApprovedByDE() {
        return [
            {'id': ClientStatusType.INCOMPLETE,'name': 'Incomplete'},
            {'id': ClientStatusType.APPROVED_NOT_FUNDED,'name': 'Approved not funded'},
        ]
    }

    globalSearch (filter: any) {
        var searchParams = new URLSearchParams();
        for (var i in filter) {
            if (! filter.hasOwnProperty(i)) continue;
            searchParams.append(i, filter[i]);
        }
        return this.http.get(`/lead/global-client-live-search`, {search: searchParams}).map(res => res.json());
    }

    getTopupDisabled(client_id)  {
        return this.http.get('/topup/is-disabled/' + client_id).map(r => r.json());
    }
    turnTopupState(client_id)  {
        return this.http.put('/topup/turn-state/' + client_id, {}).map(r => r.json());
    }


    public getPurposeById(id = null) {
        return _.find(this.getPurpose(), {id: id});
    }


    public getStatusName(key) {
        return this.statusNames[key]
    }

    static getEmptyScheduleModel(): ClientScheduleModel {
        return {
            schedule_time: ''
        }
    }

    public hasNewClass(notes) {
        let res = false;
        for (let item of notes) {
            if (item['has_new']) {
                res = true;
                break;
            }
        }
        return res;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/clients/clients.service.ts